import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['ReceiveJob', 'ReasonMasters'],
});
export const receivejobApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllReceiveJobs: builder.query({
      query: () => `receive_jobs/`,
      providesTags: ['ReceiveJob'],
    }),

    findReceiveJobTrailerbyCardId: builder.query({
      query: (trailer_card_id) =>
        `trailers/?trailer_card_id=${trailer_card_id}`,
      providesTags: ['ReceiveJob'],
    }),
    findReceiveJobDriverbyCode: builder.query({
      query: (tlep_code) => `drivers/?tlep_code=${tlep_code}`,
      providesTags: ['ReceiveJob'],
    }),

    findAllDriverConfirmByUser: builder.query({
      query: () => `driver_confirm_message_by_user/`,
      providesTags: ['ReceiveJob'],
    }),

    findReceiveJobById: builder.query({
      query: (id) => `receive_jobs/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ReceiveJob', id: result.id }]
          : ['ReceiveJob'];
      },
    }),
    findReceiveJobConfirmById: builder.query({
      query: (id) => `receive_jobs/confirm/?dispatch_board_id=${id}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ReceiveJob', id: result.id }]
          : ['ReceiveJob'];
      },
    }),
    findReceiveJobCancelById: builder.query({
      query: (payload) => {
        let url = `receive_jobs/cancel/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ReceiveJob'],
    }),

    findAllReceiveJobByPagination: builder.query({
      query: (payload) => {
        let url = `dispatch_boards/receive_job/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ReceiveJob'],
    }),

    updateReceiveJobDispatchBoards: builder.mutation({
      query: (payload) => ({
        url: `dispatch_boards/${payload.id}/`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: ['ReceiveJob'],
    }),

    findCurrentTimeReceiveJob: builder.query({
      query: () => `server_time/`,
      keepUnusedDataFor: 0,
      providesTags: ['ReceiveJob'],
    }),

    findReceiveJobReasonMasterByModule: builder.query({
      query: (module) => `reasons/?module__name=${module}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ReasonMasters', module: result.module }]
          : ['ReasonMasters'];
      },
    }),

    findReceiveJobGroupReasonByCode: builder.query({
      query: (code) => `reasons/?&subject_reason__group__code=${code}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ReasonMasters', id: result.id }]
          : ['ReasonMasters'];
      },
    }),

    createReceiveJob: builder.mutation({
      query: (receivejob) => ({
        url: `receive_jobs/save/`,
        method: 'POST',
        body: receivejob,
      }),
      invalidatesTags: ['ReceiveJob'],
    }),
    createReceiveJobMobile: builder.mutation({
      query: (receivejob) => ({
        url: `receive_jobs/save/?is_mobile=True`,
        method: 'POST',
        body: receivejob,
      }),
      invalidatesTags: ['ReceiveJob'],
    }),
    updateReceiveJob: builder.mutation({
      query: (receivejob) => ({
        url: `receive_jobs/${receivejob.id}/`,
        method: 'PATCH',
        body: receivejob,
      }),
      invalidatesTags: ['ReceiveJob'],
    }),
    deleteReceiveJob: builder.mutation({
      query: (receivejob) => ({
        url: `receive_jobs/delete/${receivejob.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ReceiveJob'],
    }),

    createDriverConfirm: builder.mutation({
      query: (data) => ({
        url: `driver_confirm_messages/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['ReceiveJob'],
    }),
    updateReceiveJobDriverConfirm: builder.mutation({
      query: (data) => ({
        url: `driver_confirm_messages/${data.id}/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['ReceiveJob'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllReceiveJobsQuery,
  useFindReceiveJobByIdQuery,
  useCreateReceiveJobMutation,
  useUpdateReceiveJobMutation,
  useUpdateReceiveJobDispatchBoardsMutation,
  useDeleteReceiveJobMutation,
  useFindReceiveJobDriverbyCodeQuery,
  useFindAllDriverConfirmByUserQuery,
  useLazyFindAllDriverConfirmByUserQuery,
  useFindReceiveJobTrailerbyCardIdQuery,
  useFindAllReceiveJobByPaginationQuery,
  useFindCurrentTimeReceiveJobQuery,
  useFindReceiveJobReasonMasterByModuleQuery,
  useCreateDriverConfirmMutation,
  useUpdateReceiveJobDriverConfirmMutation,
} = receivejobApi;
